var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100pt",
    height: "100pt",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.578 1.1797h4.8398c3.4258 0 6.1406 2.7148 6.1406 6.1406v34.121h34.121c3.3047 0 6.1406 2.7148 6.1406 6.1406v4.8398c0 3.4258-2.832 6.1406-6.1406 6.1406h-34.121v34.121c0 3.3047-2.7148 6.1406-6.1406 6.1406h-4.8398c-3.4258 0-6.1406-2.832-6.1406-6.1406v-34.121h-34.121c-3.4258 0-6.1406-2.7148-6.1406-6.1406v-4.8398c0-3.4258 2.7148-6.1406 6.1406-6.1406h34.121v-34.121c0-3.4258 2.7148-6.1406 6.1406-6.1406z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.b08afe3f243bf8427aed08c86d3f808c.svg";
export { ForwardRef as ReactComponent };